const clamp = (value: number, min: number, max: number) =>
  Math.min(Math.max(value, min), max);

const hexToRgb = (hex: string) => {
  const normalized = hex.replace("#", "");
  if (![3, 6].includes(normalized.length)) return null;

  const fullHex =
    normalized.length === 3
      ? normalized
          .split("")
          .map((char) => `${char}${char}`)
          .join("")
      : normalized;

  const intValue = Number.parseInt(fullHex, 16);
  if (Number.isNaN(intValue)) return null;

  return {
    r: (intValue >> 16) & 255,
    g: (intValue >> 8) & 255,
    b: intValue & 255,
  };
};

export const rgba = (color: string, alpha: number) => {
  const safeAlpha = clamp(alpha, 0, 1);

  if (color.startsWith("#")) {
    const rgb = hexToRgb(color);
    if (!rgb) return color;
    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${safeAlpha})`;
  }

  if (color.startsWith("var(")) {
    return `color-mix(in srgb, ${color} ${safeAlpha * 100}%, transparent)`;
  }

  return color;
};

export const darken = (amount: number, color: string) => {
  const safeAmount = clamp(amount, 0, 1);

  if (color.startsWith("#")) {
    const rgb = hexToRgb(color);
    if (!rgb) return color;
    const factor = 1 - safeAmount;
    const darkened = {
      r: Math.round(rgb.r * factor),
      g: Math.round(rgb.g * factor),
      b: Math.round(rgb.b * factor),
    };
    return `rgb(${darkened.r}, ${darkened.g}, ${darkened.b})`;
  }

  if (color.startsWith("var(")) {
    return `color-mix(in srgb, ${color} ${(1 - safeAmount) * 100}%, black)`;
  }

  return color;
};
